import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_VERIFICAIONS_TAX } from "..";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";

const modules: OnboardingModule[] = [
  {
    type: "create_account",
    options: {
      accountTypes: ["Individual", "Business"],
      verificationLevel: "Tax"
    },
    title: "Tax verification"
  }
];

export const RouteTaxVerificaiton: React.FC = () => {
  const history = useHistory();

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_VERIFICAIONS_TAX}
      modules={modules}
      onSuccess={() => {
        history.push("/member");
      }}
    />
  );
};
